import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";
import { Panel, btnGhost } from "./ui";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FILES = [
  { name: "se-hospede-aki.zip", title: "Se Hospede AKI", desc: "Código atual do site e do painel." },
  { name: "blitz-legado.zip", title: "BlitzRadar (legado)", desc: "Backup completo do antigo bot do Telegram." },
];

export const BackupsSection = () => {
  const [busy, setBusy] = useState("");

  const download = async (name) => {
    setBusy(name);
    try {
      const r = await axios.get(`${API}/backups/${name}`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = name;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Não foi possível baixar o arquivo.");
    }
    setBusy("");
  };

  return (
    <Panel id="backups" title="Backups do código" subtitle="Arquivos .zip separados para você guardar. Senhas e chaves não vão junto." testId="backups-section">
      <div className="grid sm:grid-cols-2 gap-3">
        {FILES.map((f) => (
          <div key={f.name} className="rounded-2xl border border-slate-200 p-4 flex items-center justify-between gap-3">
            <div className="min-w-0">
              <p className="font-bold text-slate-900">{f.title}</p>
              <p className="text-xs text-slate-500">{f.desc}</p>
            </div>
            <button onClick={() => download(f.name)} disabled={!!busy} className={`${btnGhost} border border-slate-200 shrink-0`} data-testid={`backup-${f.name}`}>
              {busy === f.name ? <Loader2 size={15} className="animate-spin" /> : <Download size={15} />} Baixar
            </button>
          </div>
        ))}
      </div>
    </Panel>
  );
};
